import { Typography } from "antd"
import cls from "classnames"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { NavLink } from "react-router-dom"

import FaqCard from "./components/FaqCard"

const { Title, Text } = Typography

const data = [
  {
    title: "Join the program",
    text: "You've been enrolled in the referral program by your account manager as an exclusive member."
  },
  {
    title: "Share link or email",
    text: "Ready to go! Simply share your unique link or send an email to start referring."
  },
  {
    title: "Get rewarded in real-time",
    text: (
      <div>
        That's it! You can view the status of each referred business on the{" "}
        <NavLink to="?id=Earnings">Earnings</NavLink> tab.
      </div>
    )
  }
]

const HowItWorks = () => {
  const { t } = useTranslation()

  const { userInfo } = useSelector((state) => state.auth)
  const { theme } = useSelector((state) => state.nav)
  const isOutsider = userInfo?.referral_outsider

  return (
    <div className="howItWorks">
      <Title level={4}>{t("How it works")}</Title>
      <Text type="secondary">{t("Our referral program is made for your convenience.")}</Text>
      <div className={cls("faq-grid", { "faq-grid-outsider": isOutsider })}>
        {data.map((item, i) => (
          <FaqCard title={item.title} text={item.text} />
        ))}
      </div>
    </div>
  )
}

export default HowItWorks
